import { useState } from 'react'
import type { Item } from 'typings'
import { useFetch } from './useFetch'
import { assertFulfilled } from './utils'

type SKUResponse = {
  Id: number
  NameComplete: string
  ProductName: string
  SkuName: string
}

export function useSkusImport() {
  const [loading, setLoading] = useState(false)

  const { fetcherWrapper } = useFetch()

  function getSku(id: string): Promise<Item> {
    const url = new URL(
      `/api/proxy/catalog_system/pvt/sku/stockkeepingunitbyid/${id}`,
      window.location.origin
    )

    return fetcherWrapper(url)
      .then((r) => {
        if (r.status === 404) return Promise.reject('Not found')
        if (!r.ok) return Promise.reject('Error retrieving SKU')

        return r.json()
      })
      .then((skuResponse: SKUResponse) => ({
        id: String(skuResponse.Id),
        name: skuResponse.NameComplete,
      }))
  }

  async function importSkus(
    ids: string[]
  ): Promise<{ items: Item[]; found: number; notFound: number }> {
    setLoading(true)

    const promises = ids.map((id) => getSku(id))

    const skus = await Promise.allSettled(promises).then((resuls) => {
      return resuls.filter(assertFulfilled).map((r) => r.value)
    })

    setLoading(false)

    return {
      found: skus.length,
      notFound: ids.length - skus.length,
      items: skus,
    }
  }

  return { importSkus, loading }
}
